import { useQuery } from '@tanstack/react-query';
import usersService from '~/services/usersService';
import type { UserResponseDto } from '@bitecritic-api/src/users/dto/user.response.dto';
import { useLocale } from '~/hooks/useLocale';
export const useUserDetail = (username: string) => {
  const { currentLocale } = useLocale();
  return useQuery<UserResponseDto, Error>({
    queryKey: ['userDetail', username],
    queryFn: async () => {
      const response = await usersService.getUserDetail(username, currentLocale.language);
      if (!response) {
        throw new Error('User not found');
      }
      return response;
    },
    enabled: !!username,
  });
};

export default useUserDetail;
